module.exports = __webpack_public_path__ + "static/media/partner_img.dee37655.png";